import { isMobile } from 'mobile-device-detect';


/**
 * Get info about client device.
 * If is PC Return True.
 * If is Tablet or Mobile return False.
 */
export default function Device(): boolean
{
    return !isMobile;

  
}